/**
 * Application settings
 */
export class Settings {
    constructor(public menu: string,
                public menuType: string) {
    }
}
